import { render } from "./DataCardTable.vue?vue&type=template&id=538cba9c"
import script from "./DataCardTable.vue?vue&type=script&lang=js"
export * from "./DataCardTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__